import type { Annuaires } from '../views/contract.js';

/**
 * LES ANNUAIRES PRETS, vus de l'exterieur du magasin (`lib/annuaires.tsx`).
 *
 * CE MODULE N'A AUCUNE DEPENDANCE, ET C'EST SA RAISON D'ETRE. Les champs `lecture`
 * (`views/screens.ts`) lisent la fiche liee dans l'annuaire ; le magasin, lui,
 * importe `lib/liens.tsx`, qui importe `views/screens.ts`. Un import direct du
 * magasin par l'assembleur fermerait ce cercle, et le premier module charge
 * lirait une constante pas encore initialisee. L'instantane vit donc ici, dans
 * un module feuille que le magasin ECRIT (`poserLesAnnuaires`) et que l'assembleur
 * LIT (`annuairesLus`).
 */

/** L'instantane courant : la carte des annuaires prets, identite stable entre deux changements. */
let INSTANTANE: Annuaires = new Map();

/** Les annuaires prets, tels que le magasin les a poses en dernier. */
export function annuairesLus(): Annuaires {
  return INSTANTANE;
}

/** Pose l'instantane. Reserve au magasin (`reconstruireInstantane`). */
export function poserLesAnnuaires(carte: Annuaires): void {
  INSTANTANE = carte;
}
